export const ERRORS = {
  temporarilyUnavailable: {
    code: 'temporarily_unavailable',
    message: 'Shop login is temporarily unavailable',
  },
};

export const LOAD_TIMEOUT_MS = 10000;

export const SHOP_DISCOUNT_FLOW = 'discount';

export const SDA_PHONE_CAPTURE_CLASS = 'sda-phone-capture';

export const SHOP_DISCOUNT_AUTH_HTML = `
    <template id="shop-discount-auth-landing">
        <style>
            :host {
                display: block;
                width: 100%;
                font-family: -apple-system,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif !important;
                text-align: center;
                font-style: normal !important;
                line-height: normal;
            }

            .sda-iframe {
                width: 100%;
                height: 0;
                border: 0;
                margin: auto;
            }

            .sda-header {
                padding-bottom: 16px;
                text-align: center;
                -webkit-font-smoothing: antialiased;
            }

            .sda-header-divider {
                border-bottom: 1px solid #D9D9D9;
            }

            .sda-header-title {
                font-size: 18px;
                font-weight: 700;
                line-height: 25px;
                letter-spacing: -0.2px;
                color: #000000;
                margin-bottom: 8px;
            }

            .sda-header-description {
                font-size: 14px;
                font-weight: 400;
                color: #0F1721;
                letter-spacing: 0px;
            }

            .sda-processing {
                margin-bottom: 7px;
            }

            .sda-processing-user {
                color: #0F1721;
                font-family: -apple-system, BlinkMacSystemFont, San Francisco, Roboto, Segoe UI, Helvetica Neue, sans-serif;
                font-size: 12px;
                letter-spacing: 0px;
                line-height: 21px;
                margin: 12px 0;
                min-height: 21px;
                overflow: hidden;
                text-align: left;
                text-overflow: ellipsis;
                text-rendering: optimizelegibility;
                white-space: nowrap;
                -webkit-font-smoothing: antialiased;
            }

            .sda-phone-capture {
                margin: 0 20px;
            }

            .sda-phone-capture,
            .sda-phone-capture a {
                color: #424242;
            }

            .sda-phone-capture h3 {
                font-size: 12px;
                margin: 0px 0 5px 0;
            }

            .sda-disclosure {
                border: 1px solid #eee;
                border-radius: 5px;
                margin-bottom: 24px;
                padding: 10px;
                text-align: left;
            }

            .sda-disclosure-text-container {
                border: none;
                width: 100%;
            }

            .sda-phone-capture button {
                /* TODO: Centralize styling of shop branded buttons: https://github.com/Shopify/shop-identity/issues/1252 */
                border: 0;
                border-radius: 4px;
                cursor: pointer;
                font: 16px/18px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica;
                margin-bottom: 2px;
                padding: 16px;
                transition: background-color 100ms ease-in-out, opacity 100ms ease-out, color 100ms ease-in-out;
                width: 100%;
            }

            .sda-phone-capture button:last-of-type {
                margin-bottom: 0;
            }

            .sda-phone-capture button.primary {
                background: #5433EB;
                color: #fff;
            }

            .sda-phone-capture button.primary:hover {
                background: #7f68e9;
            }

            .sda-phone-capture button.secondary {
                background: none;
                color: #5433EB;
            }

            .sda-phone-capture button.secondary:hover {
                color: #7b61f0;
            }

            .sda-hidden {
                position: absolute;
                height: 0 !important;
                border: 0;
                padding: 0;
                margin: 0;
                visibility: hidden;
                overflow: hidden;
            }

            discount-code {
                margin: 0 20px;
            }
        </style>
        <shop-sheet-modal data-nametag="shop-portal-provider" data-type="modal" data-variant="leadCapture">
            <div class="sda-header sda-header-divider sda-hidden">
                <h2 class="sda-header-title"></h2>
                <div class="sda-header-description"></div>
            </div>
            <div class="sda-content">
                <iframe class="sda-iframe sda-hidden" tabindex="0"></iframe>
                <div class="sda-phone-capture sda-hidden">
                    <div class="sda-disclosure">
                        <h3 class="sda-disclosure-heading"></h3>
                        <iframe sandbox="allow-same-origin allow-popups" class="sda-disclosure-text-container"></iframe>
                    </div>
                    <div class="sda-phone-capture-buttons">
                        <button class="primary sda-phone-capture-confirm"></button>
                        <button class="secondary sda-phone-capture-decline"></button>
                    </div>
                </div>
                <div class="sda-processing sda-hidden">
                    <div class="sda-processing-user"></div>
                    <div class="sda-processing-status"></div>
                </div>
            </div>
        </shop-sheet-modal>
    </template>`;

export const DISCLOSURE_TEXT_STYLE = `
    <style>
        body {
            font-family: -apple-system,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif !important;
            font-style: normal !important;
            margin: 0;
        }

        .sda-disclosure-text {
            color: #424242;
            font-size: 12px;
            line-height: 14px;
            margin: 0;
        }

        .sda-disclosure-text a {
            color: #424242;
        }
    </style>`;
